export const SIZE = {
    MAX_UPLOAD: 3e9, // 3 GB
    MAX_UPLOAD_AUDIO: 1e9, // 1 GB
    MIN_UPLOAD: 20, // 20 bytes
};
export const UNCATEGORIZED_FLAG = 'Uncategorized';
// The studio-api system user ("Assets Ingest Process") that holds the editor
// lock while an AI job builds a story. Detected by id where the surface has it
// (e.g. GET /versions -> lockedByUserId), falling back to the display name
// (the draftStoryPreviews rows expose only lockedUserName).
export const AI_LOCK_USER_ID = 22;
export const AI_LOCK_USER_NAME = 'Assets Ingest Process';
export function isAiLock({ userId, userName, } = {}) {
    if (userId != null && String(userId) === String(AI_LOCK_USER_ID)) {
        return true;
    }
    return userName === AI_LOCK_USER_NAME;
}
export const STORYBOARD_UI_FEATURES = [
    'link_delete',
    'link_info',
    'link_makeACopy',
    'link_share_on_slack',
    'publish',
    'btn_edit',
    'btn_makeACopy',
    'btn_useThisStoryBoard',
    'mass_produce',
    'btn_add2MyTemplates',
];
